import { Controller } from 'react-hook-form';

import { Label, RequiredAsterisk } from '@components';
import { SelectOption } from '@types';

import { useStyles } from './ControlledSelect.styles';
import { SelectBranded } from '../SelectBranded';

interface IControlledSelect {
  /** The field name within the given module. */
  fieldName: string;
  /** The dropdown options to be rendered. */
  options: SelectOption[];
  /** The placeholder text to be shown when no value has been selected. */
  placeholder?: string;
  /** The field label. */
  label: string;
  required?: boolean;
}

/**
 * An MUI NativeSelect component hooked up to React Hook Form.
 */
export const ControlledSelect = ({
  fieldName,
  options,
  placeholder = '',
  label,
  required,
  ...props
}: IControlledSelect) => {
  const classes = useStyles();

  return (
    <Controller
      name={fieldName}
      render={({ field }) => (
        <div className={classes.formControl}>
          <Label htmlFor={fieldName}>
            {label}
            {required && <RequiredAsterisk />}
          </Label>
          <SelectBranded
            {...field}
            options={options}
            displayEmpty
            className={classes.root}
            label={placeholder}
            inputProps={{
              'data-cy': fieldName,
              'data-testid': fieldName,
            }}
          />
        </div>
      )}
      {...props}
    />
  );
};
